/* @flow */

import {
  black100,
  black75,
  black65,
  black55,
  black45,
  black35,
  black25,
  black15,
  black5,
} from 'plugin/light/style/palette';
import { listReset } from 'src/shared/app/base/style/token/helper';

/*
 |------------------------------------------------------------------------------
 | Styles
 |------------------------------------------------------------------------------
 */

export default {
  list: {
    extend: listReset,

    display: 'flex',
    flexWrap: 'wrap',
  },
  item: {
    margin: [0, 10, 10, 0],
  },
  swatch: {
    width: 80,
    height: 80,
  },
  blacks: {
    '& :nth-child(1) $swatch': {
      backgroundColor: black100,
    },
    '& :nth-child(2) $swatch': {
      backgroundColor: black75,
    },
    '& :nth-child(3) $swatch': {
      backgroundColor: black65,
    },
    '& :nth-child(4) $swatch': {
      backgroundColor: black55,
    },
    '& :nth-child(5) $swatch': {
      backgroundColor: black45,
    },
    '& :nth-child(6) $swatch': {
      backgroundColor: black35,
    },
    '& :nth-child(7) $swatch': {
      backgroundColor: black25,
    },
    '& :nth-child(8) $swatch': {
      backgroundColor: black15,
    },
    '& :nth-child(9) $swatch': {
      backgroundColor: black5,
    },
  },
};
